<template>
  <div>
    <div
      v-if="titleType == 'collapsible'"
      class="tableTitle d-flex flex-row pointer"
      @click="localExpand = !localExpand"
    >
      <div
        :class="showMobile ? 'font-weight-bold' : 'title'"
        class="d-flex flex-row"
      >
        <slot name="image"></slot>
        <div>{{ title }}</div>
      </div>

      <v-spacer></v-spacer>
      <v-icon>mdi-{{ localExpand ? "chevron-up" : "chevron-down" }}</v-icon>
    </div>

    <div v-if="headers && groups && localExpand" class="my-2 my-sm-4">
      <data-table
        v-if="!showMobile"
        :title="titleType == 'header' ? title : null"
        :headers="headers"
        :groups="groups"
        :notes="notes"
        :hasHeaders="hasHeaders"
        :notesClass="notesClass"
      >
        <template #image> <slot name="image"></slot></template
      ></data-table>

      <div v-else>
        <!-- will show the title IF the table is being displayed in the "mobile" format but it's on an ipad (only for big tables).  -->
        <div
          v-if="showMobile && isTablet"
          class="tableTitle text-h6 py-1 px-2 text-center mt-4 d-flex flex-row"
        >
          <slot name="image"></slot>
          {{ title | titleize }}
        </div>
        <data-table-mobile
          class="width100p"
          :title="titleType == 'header' ? title : null"
          :headers="headers"
          :groups="groups"
          :notes="notes"
          :hasHeaders="hasHeaders"
          :notesClass="notesClass"
        ></data-table-mobile>
      </div>
      <!-- <div v-if="notes && notes != ''" class="ma-2 caption">
        Notes:<span v-html="notes"></span>
      </div> -->
    </div>
  </div>
</template>

<script>
import DataTableMobile from "@/components/pagesStuff/DataTableMobile";
import DataTable from "@/components/pagesStuff/DataTable";

export default {
  name: "ResponsiveTable",
  components: { DataTableMobile, DataTable },
  props: {
    headers: null,
    groups: null,
    title: null,
    titleStyle: null,
    titleType: { type: String, default: "header" }, // null, "collapsible", or "none"
    notes: null,
    // id: null,
    expandAll: { type: Boolean, default: true },
    notesClass: { type: String, default: "caption" },
  },
  data: function () {
    return {
      localExpand: true,
    };
  },
  methods: {},
  computed: {
    isMobile: function () {
      return !this.$vuetify.breakpoint.smAndUp;
    },
    isTablet: function () {
      return this.$vuetify.breakpoint.name == "sm";
    },
    showMobile: function () {
      let rtn = this.isMobile;
      // if it's a big table on an ipad show the mobile version (otherwise it was getting to wide)
      if (this.headers.length > 5 && this.isTablet) rtn = true;
      return rtn;
    },
    hasHeaders: function () {
      let rtn = false;
      this.headers.forEach((h) => {
        if (h && h != "") rtn = true;
      });

      return rtn;
    },
  },
  watch: {
    expandAll(val) {
      this.localExpand = val;
    },
  },
  mounted() {
    this.localExpand = this.expandAll;
  },
};
</script>

<style scoped>
.groupHeader {
  background-color: #bfe7ff;
}
.headerCell {
  background-color: #f0f9ff;
  min-width: 65px;
}
.tableBorder {
  border: 1px solid #95b8d1;
}
table td {
  border: 0.5px solid #cbe0ef;
}
.tableTitle {
  background-color: #bfe7ff;
  border-bottom: 1px solid #95b8d0;
  padding: 10px;
}
.borderBottom {
  border-bottom: 1px solid #e3e3e3;
}
</style>
